import { render, staticRenderFns } from "./IconStarEmpty.vue?vue&type=template&id=1d5d090b"
import script from "./IconStarEmpty.vue?vue&type=script&lang=js"
export * from "./IconStarEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports